<template>
  <div class="d-block d-md-none" v-if="$route.name != 'corridor2'">
    <input type="checkbox" id="drawer-toggle" name="drawer-toggle" />
    <label for="drawer-toggle" id="drawer-toggle-label"></label>
    <nav id="drawer">
      <div
        class="sidebar-header d-flex justify-content-between border-bottom px-3 pb-3"
      >
        <div>
          <MenuIcon />
          منو
        </div>
        <button class="bg-transparent border-0 js__close_drawer">
          <CloseIcon />
        </button>
      </div>
      <ul class="sidebar-linka">
        <li>
          <router-link to="/TourismService">
            <Eghamatgah />
            خدمات گردشگری
          </router-link>
        </li>
        <li>
          <router-link to="/Ticket">
            <Eghamatgah />
            بلیط
          </router-link>
        </li>
        <li>
          <router-link to="/residence">
            <Eghamatgah />
            اقامتگاه
          </router-link>
        </li>
        <li>
          <router-link to="/restaurant">
            <RsturanIcon />
            غذا</router-link
          >
        </li>
        <li>
          <router-link to="/corridor2">
            <CoridorIcon />
            نقشه سفر</router-link
          >
        </li>
        <li>
          <router-link to="/tour">
            <TurIcon />
            تور</router-link
          >
        </li>
        <li>
          <router-link to="/blog">
            <TurIcon />
            ایران گردی</router-link
          >
        </li>
      </ul>
    </nav>

    <div class="mobile-menu-opener">
      <div class="d-flex">
        <div class="js___open_drawer">
          <MenuIcon />
          <div>منو</div>
        </div>
        <router-link to="/">
          <HomeIcon class="stroke-2" />
          <div>خانه</div>
        </router-link>
        <div>
          <MobSearchIcon />
          <div>جستجو</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeIcon from "@/assets/svg/HomeIcon.svg";
import MenuIcon from "@/assets/svg/MenuIcon.svg";
import MobSearchIcon from "@/assets/svg/MobSearchIcon.svg";
import CloseIcon from "@/assets/svg/CloseIcon.svg";
import Eghamatgah from "@/assets/svg/Eghamatgah.svg";
import TurIcon from "@/assets/svg/TurIcon.svg";
import CoridorIcon from "@/assets/svg/CoridorIcon.svg";
import RsturanIcon from "@/assets/svg/RsturanIcon.svg";
import $ from "jquery";
export default {
  name: "sidebar-comp",
  data() {
    return {};
  },
  components: {
    HomeIcon,
    MenuIcon,
    MobSearchIcon,
    CloseIcon,
    Eghamatgah,
    RsturanIcon,
    CoridorIcon,
    TurIcon,
  },
  mounted() {
    $(".js___open_drawer").click(function () {
      $("#drawer-toggle-label").click();
    });
    $(".js__close_drawer").click(function () {
      $("#drawer-toggle-label").click();
    });

    $(".sidebar-linka a").click(function () {
      $("#drawer-toggle-label").click();
    });
  },
  methods: {},
};
</script>
